import React, { useContext } from 'react';
import { getOcbDomain } from 'utils/getDomains';

const bootstrapRootDomain = getOcbDomain();

export const RootDomainContext = React.createContext(bootstrapRootDomain);

export function withRootDomain(Component) {
    return function ComponentWithRootDomain(props) {
        return (
            <RootDomainContext.Consumer>
                {(rootDomain) => <Component {...props} rootDomain={rootDomain} />}
            </RootDomainContext.Consumer>
        );
    };
}

export const useRootDomain = () => useContext(RootDomainContext);
